import { getBezierPath, StepEdge } from '@xyflow/react';
import { Plus } from 'lucide-react';

import { Button } from '@/components/ui/button';

// Custom Edge that renders a StepEdge path and adds a Plus Button
const CustomEdge = (props) => {
  const {
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
    data,
    // We don't need id, style, markerEnd directly here as StepEdge handles them
  } = props;

  // Use getBezierPath just to calculate the center point for the button
  // The actual edge path will be drawn by StepEdge
  const [, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  const showAddButton = data?.showAddButton !== false;
  const allowBranchStep = data?.allowBranchStep !== false;

  const handleEdgeButton = () => {
    data.setIsActionTypeModalOpen(true);
    data.setActionSourceNode(props.source);
  };

  return (
    <>
      {/* Render the built-in StepEdge component, passing all props */}
      <StepEdge {...props} />

      {/* Render the custom button in the middle */}
      {showAddButton && (
        <foreignObject
          width={24}
          height={24}
          x={labelX - 12} // Position based on calculated center
          y={labelY - 12}
          className='pointer-events-all cursor-pointer'
          requiredExtensions='http://www.w3.org/1999/xhtml'
        >
          <Button
            variant='ghost'
            size='icon'
            className='h-6 w-6 rounded-full bg-primary p-0 text-primary-foreground hover:bg-primary/90'
            onClick={handleEdgeButton}
          >
            <Plus className='h-4 w-4' />
          </Button>
        </foreignObject>
      )}
    </>
  );
};

export default CustomEdge;
